import { Component, ViewEncapsulation } from '@angular/core';
import { FiDocumentTemplateItemOptionsBase } from '../document-template-item-options-base';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-document-template-item-options-simple-text',
    templateUrl: './document-template-item-options-simple-text.component.html',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-document-template-item-options-simple-text' },
    standalone: false,
})
export class FiDocumentTemplateItemOptionsSimpleTextComponent extends FiDocumentTemplateItemOptionsBase {
    ObjectTypes = ObjectTypes;
}
